import { ActionContext, IAction } from "../../../UI.Controls/Actions/IAction";
import { ToolbarPage } from "../Toolbar/ToolbarPage";
import { Icon, MenuTypes } from "./FormUI";

export class ToolbarActionPrescription {
    constructor(public menuType: MenuTypes, public action: IAction, public element?: HTMLElement, public actionName?: string, public page?: ToolbarPage) {}
}

/**
 * Rozhraní pro definici vytvářené akce
 */
export interface StandardActionDefinitionBase {
    context?: ActionContext;
}

/**
 * Rozhraní pro definici vizuální podoby akce
 */
export interface StandardActionDefinitionForUI {
    locKey?: string;
    priority: number;
    icon?: Icon | string;
    classes?: string[];
    isTwoState?: boolean;
}

/**
 * Výčet známých podporovaných rozšiřujících properties
 */
export enum MenuUIExtensionProperties {
    fulltextSupported = "fulltextSupported",
    filterContainer = "filterContainer",
}
